import { Button, Card, Checkbox, Col, Divider, Flex, Modal, Row, Space, Spin, Switch } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { Detail } from "components/elements";
import { DatePicker, Input, Select } from "components/form";
import { FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import EmployeeSalaryTable from "components/table/EmployeeSalaryTable";
import { Form, Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatBankAccountNo, formatPromptpayNo } from "utils/formatter/formatCommon";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import employeeSalarySalaryModalSchema, { initialValues as INITIAL_VALUES, } from "../schemas/employeeSalarySalaryModalSchema";
import styles from "../styles/EmployeeForm.module.css";
import FormSwitch from "components/form/FormProvide/FormSwitch";

// function formatBankAccountNo2(bankAccountNo) {
//   if (!bankAccountNo) return '-';

//   const cleanNumber = bankAccountNo.replace(/\D/g, '');

//   if (cleanNumber.length <= 6) {
//     return cleanNumber;
//   }

//   const part1 = cleanNumber.slice(0, 3);
//   const part2 = cleanNumber.slice(3, 6);
//   const part3 = cleanNumber.slice(6);

//   return `${part1}-${part2}-${part3}`;
// }

const EmployeeSalarySalary = ({
  movementByTypePayment = [],
  movementGroupOptions = [],
  bankGroupType = [],
  employmentTypeOptions = [],
  currentSalary = {},
  pagination = {},
  isLoading = true,
  salaryList = [],
  isModalOpen = false,
  isMovement = {},
  onChange = () => { },
  onSubmit = () => { },
  onSubmitModal = () => { },
  onCancel = () => { },
  onRowClick = () => { },
  onRowDelete = () => { },
  isVisible = false,
  setIsVisible = () => { },
  onEdit = () => { },
  handleToggleVisibility
}) => {
  const { t, i18n } = useTranslation();
  const [edit, setEdit] = useState(false)
  const { roles } = useSelector((state) => state.company);
  const [form] = useForm(null)
  const checkDisableVisible = () => {
    return roles?.includes("ACCESS_DATA_SECURITY|EMPLOYEE|SALARY") ? false : true
  }

  useEffect(() => {
    if (currentSalary.salary) {
      form.setFieldsValue({
        'salary': currentSalary?.salary.replace(/,/g, "")
      })
      form.setFieldsValue({
        'importSpecialPeriod': currentSalary?.importSpecialPeriod
      })
    }
  }, [currentSalary?.importSpecialPeriod, currentSalary.salary, form])

  const importSwitch = useCallback(() => {
    return (<Switch checked={currentSalary?.importSpecialPeriod === "Y" || currentSalary?.importSpecialPeriod === true} name="importSpecialPeriod" disabled />)
  }, [currentSalary.importSpecialPeriod])
  console.log("currentSalary", currentSalary);

  return (
    <>
      {/* <CardContainer width="100%" height="fit-content"> */}
      <Modal
        destroyOnClose
        title={!isMovement?.id ? t("salary.label.save_movement") : t("salary.label.edit_movement")}
        open={isModalOpen}
        onCancel={() => {
          const cancelBtn = document.getElementById("movement_cancelBtn");
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
            setEdit(false)
          }
        }}
        width="1000px"
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Formik
          enableReinitialize
          initialValues={{ ...INITIAL_VALUES, ...isMovement }}
          onSubmit={(values) => {
            onSubmitModal(values)
            setEdit(false)
          }}
          validationSchema={employeeSalarySalaryModalSchema}
        >
          {({ values, submitForm, setFieldValue, resetForm }) => (
            <Form>
              <Space direction="vertical" size={6} style={{ width: "100%" }}>
                {!isMovement?.id ?
                  <Flex justify="end">
                    <Switch
                      name="forceSave"
                      label={t("salary.label.force_save")}
                      size="large"
                      onChange={(value) => setFieldValue("forceSave", value)}
                    />
                  </Flex>
                  : null}
                <Divider />
                <Row gutter={[24, 10]}>
                  {values?.forceSave === false ?
                    <><Col span={12}>
                      <Select
                        name="movementTypeListId"
                        label={t("employeeShift.table.movementType")}
                        placeholder={t("common.pleaseSelect")}
                        size="large"
                        options={movementGroupOptions}
                        mode="multiple"
                        disabled
                      />
                    </Col><Col span={12}>
                        <DatePicker
                          name="effectiveDate"
                          label={t("employeeShift.table.effectiveDate")}
                          placeholder={t("common.placeholder.ddmmyyyy")}
                          size="large"
                          // format={formatDate}
                          value={values.startDate}
                        // onChange={(date) => setFieldValue("effectiveDate",)}
                        // disabled
                        />
                      </Col><Col span={24}>
                        <Input
                          name="remark"
                          label={t("salary.label.remark")}
                          // placeholder="Remark"
                          size="small"
                          type="textarea" />
                      </Col>
                    </>
                    : <Col span={24}>
                      <Input
                        name="remark"
                        label={t("salary.label.remark")}
                        // placeholder="Remark"
                        size="small"
                        type="textarea" />
                    </Col>}

                  <Col span={12}>
                    <Card style={{ height: "100%", width: "100%", border: "0.01px solid" }}>
                      <h3>{t("salary.label.old_data")}</h3>
                      {/* <Detail
                        open={isMovement?.oldDataShow?.paymentMethod}
                        label={t("salary.label.payment_method")}
                        value={isMovement?.oldDataShow?.paymentMethod}
                      />
                      <Detail
                        open={isMovement?.oldDataShow?.bankAccountId}
                        label={t("salary.label.bank_account")}
                        value={isMovement?.oldDataShow?.bankAccount}
                      />
                      <Detail
                        open={isMovement?.oldDataShow?.bankAccountNo}
                        label={t("salary.label.bank_account_no")}
                        value={isMovement?.oldDataShow?.bankAccountNo}
                      />
                      <Detail
                        open={isMovement?.oldDataShow?.employmentTypeId}
                        label={t("salary.label.employment_type")}
                        value={isMovement?.oldDataShow?.employmentType}
                      /> */}
                      <Detail
                        open={isMovement?.oldDataShow?.salary}
                        label={t("salary.label.salary")}
                        value={isMovement?.oldDataShow?.salary}
                      />
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card style={{ height: "100%", width: "100%", border: "0.01px solid" }}>
                      <h3>{t("salary.label.new_data")}</h3>
                      {/* <Detail
                        open={isMovement?.newDataShow?.paymentMethod}
                        label={t("salary.label.payment_method")}
                        value={isMovement?.newDataShow?.paymentMethod}
                      />
                      <Detail
                        open={isMovement?.newDataShow?.bankAccountId}
                        label={t("salary.label.bank_account")}
                        value={isMovement?.newDataShow?.bankAccount}
                      />
                      <Detail
                        open={isMovement?.newDataShow?.bankAccountNo}
                        label={t("salary.label.bank_account_no")}
                        value={isMovement?.newDataShow?.bankAccountNo}
                      />
                      <Detail
                        open={isMovement?.newDataShow?.employmentTypeId}
                        label={t("salary.label.employment_type")}
                        value={isMovement?.newDataShow?.employmentType}
                      /> */}
                      <Detail
                        open={isMovement?.newDataShow?.salary}
                        label={t("salary.label.salary")}
                        value={isMovement?.newDataShow?.salary}
                      />
                    </Card>
                  </Col>
                </Row>
                <div style={{ height: 12 }} />
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="movement_cancelBtn"
                      type="default"
                      onClick={() => {
                        resetForm();
                        onCancel();
                      }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button type="primary" loading={isLoading} disabled={isLoading} htmlType="submit" style={{ backgroundColor: "var(--button-color)" }}>
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Space>
            </Form>
          )}
        </Formik>
      </Modal>
      {!edit ?
        <Spin spinning={isLoading}>
          <Card>
            <div>
              <Flex justify="space-between" align="center">
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("employee.salary.header")}</span>
                <Flex gap={10}>
                  {roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|SALARY") &&
                    <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                      icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                      onClick={handleToggleVisibility}
                    // disabled={checkDisableVisible()}
                    />
                  }
                  {roles.includes("UPDATE_EMPLOYEE|SALARY|SALARY") &&
                    <Button
                      onClick={() => {
                        setEdit(!edit)
                        onEdit()
                        form.setFieldsValue({
                          ...currentSalary,
                          paymentMethod: currentSalary?.paymentMethod != null ? currentSalary?.paymentMethod : null,
                        })

                      }}
                      type="primary"
                      style={{ width: "max-content", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                    >
                      <Flex align="center" justify="center" gap={8}>
                        <EditIcon />
                        {t("Salary.edit").toUpperCase()}
                      </Flex>
                    </Button>}
                </Flex>
              </Flex>
              <Divider className={styles.customDivider} />
            </div>
            <Flex vertical style={{ rowGap: "16px" }}>
              <Flex vertical style={{ gap: "12px" }}>
                <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.payment-methods')}</span>
                {currentSalary?.paymentMethod ?
                  currentSalary?.paymentMethod == 'BANK' ?
                    <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.bank")}</span> :
                    currentSalary?.paymentMethod == 'PROMPTPAY' ?
                      <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.promptpay")}</span> :
                      <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.cash")}</span>
                  // <Radio.Group
                  //   required
                  //   optionType="button"
                  //   buttonStyle="solid"
                  //   name="paymentMethod"
                  //   value={currentSalary.paymentMethod}
                  //   label={`${t("employee.salary.label.payment_methods")}`}
                  //   options={[
                  //     {
                  //       label: t("employee.salary.label.cash"),
                  //       value: "CASH",
                  //     },
                  //     {
                  //       label: t("employee.salary.label.bank"),
                  //       value: "BANK",
                  //     },
                  //   ]}
                  // />
                  : '-'}
                {currentSalary?.paymentMethod == 'PROMPTPAY' &&
                  <Col span={12}>
                    <Flex vertical={true} style={{ gap: "12px" }}>
                      <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..bank-account-no-0')}</span>
                      <span style={{ fontSize: "16px" }}>
                        {currentSalary?.promptpayNo ? formatPromptpayNo(currentSalary?.promptpayNo, isVisible) : '-'}
                      </span>
                    </Flex>
                  </Col>
                }

              </Flex>
              {currentSalary?.paymentMethod == 'BANK' &&
                <Flex style={{ rowGap: "16px" }}>
                  <Col span={12}>
                    <Flex vertical={true} style={{ gap: "12px" }}>
                      <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.bank-account')}</span>
                      <Flex>
                        {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon && (
                          <img
                            src={bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon}
                            alt="Bank icon"
                            style={{ width: "30px", marginRight: "8px" }}
                          />
                        )}
                        <span style={{ alignContent: "center", fontSize: "16px" }}>
                          {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.["name" + (i18n.language === 'en' ? "En" : "")] || "-"}
                        </span>
                      </Flex>
                    </Flex>
                  </Col>

                  <Col span={12}>
                    <Flex vertical={true} style={{ gap: "12px" }}>
                      <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..bank-account-no-0')}</span>
                      <span style={{ fontSize: "16px" }}>
                        {currentSalary?.bankAccountNo ? formatBankAccountNo(currentSalary?.bankAccountNo, isVisible) : '-'}
                      </span>
                    </Flex>
                  </Col>
                </Flex>
              }

              <Flex style={{ rowGap: "16px" }}>
                <Col span={12}>

                  <Flex vertical={true} style={{ gap: "12px" }}>
                    <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..employment-type-0')}</span>
                    <span style={{ fontSize: "16px" }}>
                      {currentSalary?.employmentType?.["name" + (i18n.language === 'en' ? "En" : "")] || "-"}
                    </span>
                  </Flex>
                </Col>
                <Col span={12}>
                  <Flex vertical={true} style={{ gap: "12px" }}>
                    <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.salary')}</span>
                    {/* <span style={{ fontSize: "16px" }}>{isVisible ? currentSalary?.salary : "xxxx.xx"}</span> */}
                    <span style={{ fontSize: "16px" }}>{currentSalary?.salary}</span>
                  </Flex>
                </Col>
              </Flex>

              <Flex>
                <Col span={12}>
                  <Flex gap={8} align="center">
                    <span style={{ fontSize: "16px", color: "#667085" }}>
                      {t("SalarySalary.import_special_period")}
                    </span>
                    {importSwitch()}
                  </Flex>
                </Col>
              </Flex>
            </Flex>
          </Card>
        </Spin>
        :
        <Space style={{ width: "100%" }} size={24} direction="vertical">
          <FormAntd
            form={form}
            initialValues={{
              ...currentSalary,
              paymentMethod: currentSalary?.paymentMethod != null ? currentSalary?.paymentMethod : "CASH",
            }}
            onFinish={async (value) => {
              console.log("formform", form);
              onSubmit(value, form, setEdit)
            }}
          // validationSchema={schema}
          >
            <FormItem shouldUpdate={() => false}>
              {({ getFieldValue, setFieldValue, submitForm, resetForm }) => (
                <Spin spinning={isLoading}>
                  {/* <Button onClick={() => { setEdit(!edit) }}>EDIT</Button> */}
                  <Card>
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("employee.salary.header")}</span>
                    <Divider className={styles.customDivider} />
                    <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.payment-methods')}</span>
                    <Row gutter={[24, 16]}>
                      <Col span={24}>
                        {currentSalary?.paymentMethod ?
                          currentSalary?.paymentMethod == 'BANK' ?
                            <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.bank")}</span> :
                            currentSalary?.paymentMethod == 'PROMPTPAY' ?
                              <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.promptpay")}</span> :
                              <span style={{ alignContent: "center", fontSize: "16px" }}>{t("employee.salary.label.cash")}</span>
                          : '-'}
                        {/* <Radio.Group
                          required
                          disabled
                          optionType="button"
                          buttonStyle="solid"
                          name="paymentMethod"
                          onChange={(e) => {
                            setFieldValue("paymentMethod", e.target.value)
                          }}
                          value={getFieldValue("paymentMethod")}
                          label={`${t("employee.salary.label.payment_methods")}`}
                          options={[
                            {
                              label: t("employee.salary.label.cash"),
                              value: "CASH",
                            },
                            {
                              label: t("employee.salary.label.bank"),
                              value: "BANK",
                            },
                          ]}
                        /> */}
                      </Col>
                      {getFieldValue("paymentMethod") == 'PROMPTPAY' &&
                        <Col span={24}>
                          <Flex vertical={true} style={{ gap: "12px" }}>
                            <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..bank-account-no-0')}</span>
                            <span style={{ fontSize: "16px" }}>
                              {currentSalary?.promptpayNo ? formatPromptpayNo(currentSalary?.promptpayNo, isVisible) : '-'}
                            </span>
                          </Flex>
                        </Col>
                      }
                      {getFieldValue("paymentMethod") === "BANK" && (
                        <>
                          <Col span={12}>
                            <Flex vertical={true} style={{ gap: "12px" }}>
                              <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary.bank-account')}</span>

                              <Flex>
                                {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon && (
                                  <img
                                    src={bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.icon}
                                    alt="Bank icon"
                                    style={{ width: "30px", marginRight: "8px" }}
                                  />
                                )}

                                <span style={{ alignContent: "center", fontSize: "16px" }}>
                                  {bankGroupType.find(o => o.id === currentSalary?.bankAccount?.id)?.["name" + (i18n.language == 'en' ? "En" : "")] || "-"}
                                </span>
                              </Flex>
                            </Flex>
                          </Col>
                          <Col span={12}>
                            {/* <FormInput
                              required
                              disabled
                              name="bankAccountNo"
                              label={`${t("employee.salary.label.bank_account_no")}`}
                              placeholder="-"
                              size="large"
                            /> */}
                            <Flex vertical={true} style={{ gap: "12px" }}>
                              <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..bank-account-no-0')}</span>
                              <span style={{ fontSize: "16px" }}>{formatBankAccountNo(currentSalary?.bankAccountNo ? currentSalary?.bankAccountNo : '-', true)}</span>
                            </Flex>
                          </Col>
                        </>
                      )}
                      <Col span={12}>
                        {/* <FormSelect
                          // required
                          disabled
                          name="employmentTypeId"
                          label={
                            <>
                              {`${t("employee.salary.label.employment_type")}`}
                              <Popover content={t("employee.salary.popover.employment_type")} trigger="hover">
                                <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                              </Popover>
                            </>
                          }
                          placeholder={t("common.pleaseSelect")}
                          size="large"
                          options={employmentTypeOptions.map((record) => ({
                            label: i18n.language === "en" ? record.nameEn : record.name,
                            value: record.id,
                          }))}
                        /> */}

                        <Flex vertical={true} style={{ gap: "12px" }}>
                          <span style={{ fontSize: "16px", color: "#667085" }}>{t('SalarySalary..employment-type-0')}</span>
                          <span style={{ fontSize: "16px" }}>
                            {currentSalary?.employmentType?.["name" + (i18n.language === 'en' ? "En" : "")] || "-"}
                          </span>
                        </Flex>
                      </Col>
                      <Col span={12}>
                        <FormInputNumber
                          required
                          name="salary"
                          label={t("SalarySalary.salary")}
                          placeholder={t("employee.salary.label.enter_salary")}
                          size="large"
                          controls={false}
                          min={0.00}
                          maxLength={13}
                        />
                      </Col>
                      <Col span={12}>
                        <FormSwitch
                          name="importSpecialPeriod"
                          label={
                            <span style={{ fontSize: "16px", color: "#667085" }}>
                              {t("SalarySalary.import_special_period")}
                            </span>
                          }
                          vertical={false}
                        />
                      </Col>
                    </Row>
                    <Row justify="end" style={{ paddingTop: "24px" }}>
                      <Space size={12}>
                        <Button type="default" onClick={() => {
                          onCancel()
                          setEdit(false)
                        }}
                          style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                        >
                          {t("common.cancel").toUpperCase()}
                        </Button>
                        <Button type="primary" htmlType="submit"
                          style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                        >
                          {t("common.submit").toUpperCase()}
                        </Button>
                      </Space>
                    </Row>
                  </Card>
                </Spin>
              )}
            </FormItem>
          </FormAntd>
        </Space >
      }
      {/* </CardContainer > */}
      <div style={{ marginTop: "15px" }}>
        <EmployeeSalaryTable
          isLoading={isLoading}
          dataSource={movementByTypePayment}
          pagination={pagination}
          onChange={onChange}
          onRowClick={onRowClick}
          onRowDelete={onRowDelete}
          isVisible={isVisible}
        />
      </div>
    </>
  );
};

export default EmployeeSalarySalary;
